import React, {Fragment, useMemo} from 'react';
import {Icons, Breadcrumbs, Link, Layout, Form, Edit, List, Redirect, Button, Textarea, Dropdown, Tags, Flex} from 'components';
import {debounce, useNamedSelector} from 'helpers';
import {itemById, updateListItem} from "store/lists";
import {PriorityPopup} from ".";

export function EditListItemForm({id, context = {}}) {
  const listItem = useNamedSelector('lists.itemById', { id: id });

  const initialValues = useMemo(() => ({
    name: context.listItem?.name || '',
    note: context.listItem?.note || '',
    tagIds: context.listItem?.tagIds || '',
    ...listItem,
  }), [ id ]);

  const onChange = useMemo(() => {
    return id ? debounce(updateListItem, 1000) : updateListItem;
  }, [ id ]);

  return (
    <Form id="listItemForm" initialValues={initialValues} onChange={onChange} delay>
      <Fragment>
        {id && !listItem && <Redirect to="/lists/"/>}

        <Layout.Header justified>
          <Breadcrumbs>
            <Link to="/lists/">Lists</Link>
            <Link to={`/lists/${listItem.listId}/`}>List</Link>
            <span>
              <b>Edit List Item</b>
            </span>
          </Breadcrumbs>
        </Layout.Header>

        <List small-gutter>
          <Edit
            className="bold"
            name="name"
            placeholder="Name"
          />
          <Textarea
            single
            name="note"
            placeholder="Enter Note.."
          />
          <Dropdown
            name="priority"
            label="Priority"
            Popup={PriorityPopup}
          />
          <Tags
            name="tagIds"
          />
          <Flex className={['right', 'spacing', 'small']}>
            <Button className="primary" to={`/lists/${listItem.listId}/`}>Back</Button>
          </Flex>
        </List>

      </Fragment>
    </Form>
  )
}
